import { useEffect, useState } from "react";
import FormModal from "../../widgets/FormModal";
import { Link } from "react-router-dom";
import Header from "../../widgets/Header";
import Footer from "../../widgets/Footer";


function GeneticResearch() {
    const [show, setShow] = useState(false);
    const openIframeWindow = () => {
        setShow(!show);
    }
    return (
        <> <section className="light_bg">
            <Header />
            <div className="top_space"></div>

            <section className="ps">
                <div className="container">
                    <h1 className="hadding">EPLIMO Genetic Research: Uncovering Cardiac and Fitness Risks in the Indian Population</h1>

                    <div className="position-relative  mt-4 mb-4">
                        <img src="/assets/img/research/genetic-research.webp" alt="genetic-research" className="w100 br20" />
                    </div>

                    <h3 className="op0_8">Overview </h3>
                    <p>
                        The EPLIMO Genetic Predisposition Risk Study explores how specific genetic variants influence heart disease, endurance performance, and drug response among Indian individuals. </p>
                    <p>
                        This extensive analysis of over 1,000 genetic reports provides new insights into how our DNA shapes cardiovascular health and helps identify high-risk individuals long before clinical symptoms appear.</p>



                    <h3 className="op0_8">Study 1: Genetic Insights Reveal High Risk of Heart Attack </h3>
                    <p> An analysis of 1,000 genetic predisposition reports (ages 25–75) showed that 761 participants (76.1%) carried a genetic predisposition to myocardial infarction (heart attack).<br />
                        This finding underscores the vital role of genomics in early detection and prevention, encouraging genetic screening as a routine part of preventive cardiac care. </p>


                    <h3 className="op0_8">Study 2: 70% of Adults Show Genetic Predisposition to Heart Failure </h3>
                    <p>
                        In a randomized study of 500 individuals aged 25–75, 350 (70%) carried genetic variants linked to heart failure.
                    </p>
                    <p>
                        This high prevalence highlights the importance of early genetic risk assessment, allowing for timely lifestyle modification and personalized heart health strategies before disease progression.
                    </p>

                    <h3 className="op0_8">Study 3:  Endurance Genotypes and Cardiac Risk Markers </h3>
                    Among 500 individuals genetically inclined toward endurance performance:

                    <ul class="mb-4 dot_list">
                        <li>346 (69.2%) also had a genetic predisposition to heart failure. </li>   <li>  </li>
                        <li> 243 (70.2%) carried variants for Long QT Syndrome (LQTS), which can trigger fatal arrhythmias during prolonged exertion. </li>
                        <li>A majority also showed magnesium deficiency-related genes, known to worsen QT prolongation.</li>
                    </ul>



                    <p>
                        These results highlight the importance of comprehensive genetic screening before recommending endurance training, as athletic potential doesn’t always ensure cardiovascular safety.
                    </p>

                    <h3 className="op0_8">Study 4:  Heart Failure Risk in Marathon-Linked Genotypes </h3>

                    An EPLIMO analysis of 500 individuals with genetic markers for marathon performance found that:



                    <ul class="mb-4 dot_list">
                        <li> 325 (65%) had a predisposition to heart failure. </li>
                        <li> 210 also showed a genetic risk for Long QT Syndrome. </li>
                        <li> Most of these cases exhibited magnesium deficiency genes, amplifying cardiac vulnerability. </li>
                    </ul>
                    <p>
                        Even individuals genetically built for endurance may face hidden cardiac risks, underscoring the need for balanced training guided by genetic data.</p>

                    <h3 className="op0_8">Study 5:  Strong Genetic Link Between Heart Failure, Long QT Syndrome, and Magnesium Deficiency</h3>
                    EPLIMO analyzed 400 individuals genetically predisposed to heart failure and found:


                    <ul class="mb-4 dot_list">
                        <li> 263 (65.8%) also carried Long QT risk genes. </li>
                        <li> Among them, 239 (90.9%) had magnesium deficiency-related variants. </li>

                    </ul>
                    <p>
                        This significant overlap reinforces magnesium’s crucial role in heart rhythm stability and the importance of genetic insight for comprehensive cardiac evaluation.
                    </p>

                    <h3 className="op0_8">Study 6:  Genetic Variants Affect LDL Cholesterol and PUFA Response </h3>
                    A study of 250 individuals identified:
                    <ul class="mb-4 dot_list">
                        <li>
                            98 with a genetic risk for elevated LDL cholesterol. </li>
                        <li>
                            Over 80% had a poor cholesterol-lowering response to polyunsaturated fats (PUFAs) but responded better to monounsaturated fats (MUFAs). </li>

                    </ul>
                    <p>
                        These findings demonstrate that dietary responses are genetically individualized, and personalized nutrition can be more effective than generalized dietary guidelines for heart health.</p>

                    <h3 className="op0_8"> Study 7:  DNA Repair and Antioxidant Inefficiency in Coronary Artery Disease</h3>

                    Analysis of 250 individuals with Coronary Artery Disease (CAD) predisposition revealed:
                    <ul class="mb-4 dot_list">
                        <li>
                            207 (82.8%) had impaired DNA repair mechanisms linked to antioxidant metabolism. </li>
                    </ul>
                    <p>
                        This shows that antioxidant intake alone may not protect against oxidative stress in genetically predisposed individuals.
                        Instead, personalized nutrition and supplementation are needed to support DNA repair and reduce CAD risk.</p>

                    <h3 className="op0_8">Study 8:  Vitamin B9 Deficiency and Elevated Homocysteine in CAD Risk </h3>
                    In a study of 340 individuals genetically predisposed to CAD:



                    <ul class="mb-4 dot_list">
                        <li>
                            119 had elevated homocysteine-related risk variants. </li>
                        <li>
                            Over 70% were predisposed to Vitamin B6 and B9 deficiencies, with Vitamin B9 deficiency being the most common. </li>
                        <li>
                            Only a small number showed Vitamin B12 deficiency. </li>
                    </ul>
                    <p>These findings emphasize the role of B-vitamin metabolism in maintaining heart health and caution against indiscriminate supplement use without genetic guidance.</p>

                    <h3 className="op0_8"> Study 9:  Clopidogrel Resistance in Coronary Artery Disease </h3>
                    Genetic data from 450 individuals with CAD predisposition revealed:
                    <ul class="mb-4 dot_list">
                        <li>
                            268 (59.5%) had gene variants causing poor response to clopidogrel, a standard antiplatelet drug. </li>
                        <li>
                            Most of these individuals showed a better genetic response to warfarin instead. </li>

                    </ul>
                    <p>

                        This confirms the importance of pharmacogenomic testing for tailoring cardiac drug therapy and minimizing adverse effects.
                    </p>

                    <h3 className="op0_8"> Study 10:   Long QT and Heart Failure Risks in Genetically Enhanced Sprinters </h3>

                    In a genetic review of 500 individuals with sprint performance genotypes:
                    <ul class="mb-4 dot_list">
                        <li>
                            321 (64.2%) showed Long QT risk, and </li>
                        <li>
                            234 (72.9%) also had heart failure predisposition. </li>

                    </ul>
                    <p>
                        These results reveal that even those genetically optimized for short bursts of performance can face significant cardiac electrical risks, emphasizing safe training and medical oversight for athletes. </p>

                    <h3 className="op0_8">Genetic Insights and Their Impact on Future Cardiac Health  </h3>

                    Across all ten studies, the findings consistently show that genetic factors play a central role in determining heart health, exercise safety, and response to treatments.<br />
                    Through EPLIMO’s precision wellness model, these genetic insights can be transformed into personalized strategies that help:
                    <ul class="mb-4 dot_list">
                        <li>
                            Detect heart disease risk early
                        </li>
                        <li>
                            Tailor nutrition and supplementation </li>
                        <li>
                            Choose safer, more effective medications </li>
                        <li>
                            Design customized exercise programs that align with one’s genetic potential</li>
                    </ul>
                    <p>
                        This approach represents the future of preventive cardiology, where genetics guides every decision for a healthier, longer, and more resilient life.
                    </p>

                    <div className="pt-4 text-center">
                        <a href="genetic-risk" className="back_btn bn_btn"><i className="bi bi-chevron-left"></i></a>
                        <a href="study-reveals-running" className="next_btn bn_btn"><i className="bi bi-chevron-right"></i></a>
                    </div>

                </div>

            </section>


            <section className="you_ready_sec text-white position-relative  overflow-hidden">
                <img src="/assets/img/research/research_r_bg.webp" alt="cour raddy" className="cour_raddy mo_none" />
                <img src="/assets/img/research/research_r_bg2.webp" alt="cour raddy" className="cour_raddy pc_none" />

                <div className="container position-relative">
                    <div className="row position-relative">
                        <div className="col-md-5  ms-auto">
                            <h2 className="hadding mb-4    ">Are You Ready to Take Control of Your Future Health?</h2>
                            <p className=" mb-md-4 mb-3 ">EPLIMO is more than a health check. It’s a blueprint for living stronger,
                                longer, and happier. Don’t wait for symptoms to become problems. Take charge today and start
                                living at your peak.</p>
                            <a className="btn" onClick={() => openIframeWindow()}>Join EPLIMO<sup className="sup-font">TM</sup> Program</a>
                        </div>
                    </div>
                </div>
            </section>
            <FormModal show={show} setShow={setShow} />
            <Footer /> </section>
        </>
    );
}

export default GeneticResearch;
